// extracted by mini-css-extract-plugin
export default {"introBooker":"introBooker__3tTtz","startingPrice":"startingPrice__3XG5z","priceFrom":"priceFrom__1fH2U","price":"price__eCcj9","actionButtons":"actionButtons__bB18u","bookerButton":"bookerButton__3SJTN","voucherButton":"voucherButton__2CoSV","reassurance":"reassurance__298XP"};
    if(module.hot) {
      // 1788784374252
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  